<template>
  <div v-loading="loading">
    <app-credentials-fields v-model="model.credentialFields" />
    <button
      type="button"
      class="btn btn-primary"
      @click.prevent="$marketplace_save"
    >
      {{ $t('Save') }}
    </button>
  </div>
</template>

<script>
import MarketplaceMixins from '../mixins/MarketplaceMixins';
import AppCredentialsFields from '../components/credential-fields/CredentialFields.vue';

export default {
  name: 'AppPageMarketplaceCredentialFields',
  components: { AppCredentialsFields },
  mixins: [
    MarketplaceMixins,
  ],
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    this.$marketplace_load(this.$marketplace_getRouteId());
  },
};
</script>
